// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__20jlM","checked":"Checkbox_checked__Qh3J7","checkbox":"Checkbox_checkbox__2DiPf","checkboxHidden":"Checkbox_checkboxHidden__1K4E5"};